export const NC_QUALITY_TEAM = "Team Qualità Mecom";
export const NC_EFFECTIVENESS_CRITERION = "Controllo mensile delle consegne successive dello stesso articolo: verificare che siano presenti nuove spedizioni confermate dopo l’esecuzione del trattamento e dell’eventuale azione correttiva, senza ulteriori non conformità riferite alle consegne successive. In assenza di nuove consegne o con dati incompleti, mantenere la verifica in attesa.";

export function anniversary(day) {
    const [year, month, date] = day.split("-").map(Number);
    const last = new Date(Date.UTC(year + 1, month, 0)).getUTCDate();
    return `${year + 1}-${String(month).padStart(2, "0")}-${String(Math.min(date, last)).padStart(2, "0")}`;
}

export function ncCauseProposal(detail = {}, causes = []) {
    const cause = causes.find(item => item.id === detail.nc_causa_id);
    if (!cause || !detail.origine || !detail.nc_origine_id || detail.nc_origine_id === "O0") return "";
    const phase = detail.fase_numero ?? detail.numero_fase;
    const order = String(detail.odp || "").trim();
    const orderLabel = order.toUpperCase().startsWith("ODP") ? order : `ODP ${order}`;
    const reference = order ? `Riferimento: ${orderLabel}${phase != null && Number(phase) !== 999 ? `, fase ${phase}` : ""}. ` : "";
    return `Origine selezionata: ${detail.origine}. ${reference}${cause.label}`;
}

function plannedDay(created, days) {
    const [year, month, day] = created.split("-").map(Number);
    return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
}

export function emptyNcPlan(detail = {}, user = {}, today = new Date()) {
    const previous = detail.verifica_efficacia || {};
    const saved = detail.piano_8d || {};
    const localDay = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    const created = saved.creato_il || detail.data_creazione_8d || localDay;
    const result = {
        analisi_causa: "",
        trattamento_responsabile: "", trattamento_scadenza: null, trattamento_eseguito_il: null,
        azione_responsabile: "", azione_scadenza: null, azione_eseguita_il: null,
        verifica_responsabile: "", verifica_prevista_il: null,
        verifica_criterio: detail.scope === "internal" ? previous.criterio || "" : "",
        verifica_stato: detail.scope === "internal" ? previous.stato || "In attesa di verifica" : "In attesa di verifica",
        verifica_eseguita_il: detail.scope === "internal" ? previous.data_verifica || null : null,
        verifica_riferimento: detail.scope === "internal" ? previous.riferimento || "" : "",
        verifica_esito: detail.scope === "internal" ? previous.esito || "" : "",
        ...detail.piano_8d,
    };
    return {...result,
        creato_il: created,
        trattamento_scadenza: result.trattamento_scadenza || plannedDay(created, 7),
        azione_scadenza: result.azione_scadenza || (detail.azione_non_necessaria ? null : plannedDay(created, 30)),
        trattamento_responsabile: result.trattamento_responsabile || user.username || "",
        azione_responsabile: result.azione_responsabile || user.username || "",
        verifica_responsabile: user.username || result.verifica_responsabile || "",
        verifica_prevista_il: anniversary(created),
        verifica_criterio: NC_EFFECTIVENESS_CRITERION,
        verifica_automatica: true,
    };
}

export function ncPlanMissing(plan, noAction = false) {
    const fields = {
        analisi_causa: "Analisi della causa confermata",
        trattamento_responsabile: "Responsabile del trattamento",
        trattamento_scadenza: "Termine del trattamento",
        verifica_responsabile: "Responsabile della verifica",
        verifica_prevista_il: "Data prevista della verifica",
        verifica_criterio: "Metodo di verifica dell’efficacia",
        ...(!noAction ? {azione_responsabile: "Responsabile dell’azione correttiva", azione_scadenza: "Termine dell’azione correttiva"} : {}),
    };
    const missing = Object.entries(fields).filter(([key]) => !String(plan[key] || "").trim()
        || (["analisi_causa", "verifica_criterio"].includes(key) && String(plan[key]).trim().length < 10)).map(([, label]) => label);
    // Il server conserva o invalida gli esiti automatici dopo le modifiche al piano.
    if (!plan.verifica_automatica && plan.verifica_stato !== "In attesa di verifica") {
        if (!plan.verifica_eseguita_il) missing.push("Data effettiva della verifica");
        if (!plan.trattamento_eseguito_il) missing.push("Data di esecuzione del trattamento");
        if (!noAction && !plan.azione_eseguita_il) missing.push("Data di esecuzione dell’azione correttiva");
        if (String(plan.verifica_esito || "").trim().length < 10) missing.push("Esito ed evidenze della verifica");
        if (plan.verifica_eseguita_il < plan.trattamento_eseguito_il || (!noAction && plan.verifica_eseguita_il < plan.azione_eseguita_il)) missing.push("La verifica deve seguire l’esecuzione delle azioni");
    }
    return missing;
}

export function ncPlanForSave(plan) {
    const result = {...plan};
    for (const key of Object.keys(result)) {
        if (key.endsWith("_il") || key.endsWith("_scadenza")) result[key] = result[key] || null;
    }
    for (const key of ["verificato_da", "creato_il", "verifica_automatica", "verifica_controllo", "verifica_ultimo_controllo_il", "senza_azione_correttiva", "analisi_causa_da_confermare"]) delete result[key];
    return result;
}
